import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {DATA_SOURCE_PROVIDERS_STATE_NAME, DataSourceProvider, DataSourceProvidersState} from './dataSourceProviders';
import {Serializers} from '../../interfaces/serializer';

export const selectDataSourceProvidersState: MemoizedSelector<object, DataSourceProvidersState> = createFeatureSelector<DataSourceProvidersState>(DATA_SOURCE_PROVIDERS_STATE_NAME);

export const selectDataSourceProviders: MemoizedSelector<object, Serializers<DataSourceProvider>> = createSelector(
  selectDataSourceProvidersState,
  (state: DataSourceProvidersState): Serializers<DataSourceProvider> => state.serialized
);

export const selectDataSourceProviderComponentObjects: MemoizedSelector<object, any> = createSelector(
  selectDataSourceProvidersState,
  (state: DataSourceProvidersState): Serializers<DataSourceProvider> => state.componentObjects
);

export const selectDataSourceProvidersLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourceProvidersState,
  (state: DataSourceProvidersState): boolean => state.loading
);

export const selectDataSourceProvidersLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourceProvidersState,
  (state: DataSourceProvidersState): boolean => state.loaded
);
